import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Loading from "./loading";

const LoadingPage = ({ message }: { message?: string }) => {
  const { t } = useTranslation();
  return (
    <>
      <Loading
        isLoading
        content={
          <Typography variant={"h6"} sx={{ pt: "20px" }}>
            {message ?? t("loading_page.company")}
          </Typography>
        }
      />
    </>
  );
};

export default LoadingPage;
